var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
//@ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { useTagContext } from '@data/tag/tagContext';
import { getTagDisplayName, getTagLongName, getTagExpression } from '@data/tag/tagUtil';
import { ExpressionBlockTypes } from '@util/enums';
export function useExpSearchables() {
    var typeAheadFunctions = useBranch({
        typeAheadFunctions: ['models', 'typeaheadfunctions'],
    }).typeAheadFunctions;
    var tagData = useTagContext().tagData;
    return useMemo(function () {
        var _a;
        var typeAheadTags = tagData.tags.map(function (t) {
            var _a, _b, _c, _d;
            return ({
                blockType: ExpressionBlockTypes.TAG,
                id: t.id,
                title: getTagDisplayName(t),
                expression: getTagExpression(t),
                longName: getTagLongName(t),
                description: (_a = t.description) !== null && _a !== void 0 ? _a : '',
                parentTitle: (_d = (_c = tagData.tagById[(_b = t.ParentId) !== null && _b !== void 0 ? _b : -1]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
                type: t.type,
            });
        });
        var typeAheadFunctionsMapped = (_a = typeAheadFunctions === null || typeAheadFunctions === void 0 ? void 0 : typeAheadFunctions.map(function (taf) {
            return __assign({ blockType: ExpressionBlockTypes.FUNCTION }, taf);
        })) !== null && _a !== void 0 ? _a : [];
        return __spreadArray(__spreadArray([], __read(typeAheadTags), false), __read(typeAheadFunctionsMapped), false);
    }, [tagData, typeAheadFunctions]);
}
